import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../../services/api";

export const useSettingsUpdate = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ body }) => {
      const res = await api.put(`/settings/update`, body);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['settings'] });
    },
  });
};